module.exports = __webpack_public_path__ + "img/slide_p2.87a29d31.png";